import type React from 'react';

import { Button } from '@change/ds-core-ui';
import { LockOutlineIcon } from '@change/ds-icons';

import { Translate } from '@change-corgi/core-react/i18n';

type Props = {
	disabled: boolean;
	loading: boolean;
	useDonationLanguage: boolean;
	onClick: () => void;
};

export const SubmitButton: React.FC<Props> = ({ disabled, loading, useDonationLanguage, onClick }) => {
	const getSuffix = () => {
		return useDonationLanguage ? '_donation' : '';
	};

	return (
		<div className="flex justify-center">
			<Button
				data-qa="submit-payment-button"
				data-testid="dlocal-button"
				variant="primary"
				type="submit"
				disabled={disabled || loading}
				onClick={onClick}
				leadingIcon={<LockOutlineIcon size="x-small" />}
				className="w-full md:w-1/2"
			>
				<Translate value={`corgi.co.promote.submit_button_label${getSuffix()}`} />
			</Button>
		</div>
	);
};
